import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const SafetyWashingPpe = ({
	size,
	...props
}: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M7 23.875C5.346 23.875 4 22.529 4 20.875C4 17.61 6.079 14.453 6.168 14.32C6.353 14.042 6.666 13.875 7 13.875C7.334 13.875 7.647 14.042 7.832 14.32C7.921 14.453 10 17.609 10 20.875C10 22.529 8.654 23.875 7 23.875ZM7 16.968C6.516 18.014 6 19.461 6 20.875C6 21.426 6.449 21.875 7 21.875C7.551 21.875 8 21.426 8 20.875C8 19.461 7.484 18.015 7 16.968Z" />
		<path d="M24 8.677V6H27C27.552 6 28 5.552 28 5C28 4.448 27.552 4 27 4H13C8.5 4 6.117 8.532 6.116 8.533C6.042 8.672 6 8.831 6 9C6 9.552 6.448 10 7 10C7.382 10 7.713 9.786 7.882 9.472C7.882 9.472 9.75 6 13 6H18V8.677C15.637 9.803 14 12.214 14 15V25C14 26.654 15.346 28 17 28H25C26.654 28 28 26.654 28 25V15C28 12.213 26.363 9.802 24 8.677ZM20 6H22V8.073C21.673 8.026 21.34 8 21 8C20.66 8 20.327 8.026 20 8.073V6ZM19 16C19.551 16 20 16.449 20 17V21C20 21.551 19.551 22 19 22H16V16H19ZM26 25C26 25.551 25.551 26 25 26H17C16.449 26 16 25.551 16 25V24H19C20.654 24 22 22.654 22 21V17C22 15.346 20.654 14 19 14H16.101C16.566 11.72 18.586 10 21 10C23.757 10 26 12.243 26 15V25Z" />
	</svg>
);

export default SafetyWashingPpe;
